<template>
  <div class="main-box">
    <div class="content-cls">
      <img src="../../assets/msg_bg.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  created () {
    document.title = '默往网页版正式上线'
  }
}
</script>

<style scoped lang="scss">
.content-cls{
  font-size: 0;
  img {
    width: 100%;
  }
}
</style>
